import { RespCode } from '@constants';
import { logError } from '@log';
import { request } from './request';
// import { mockGetReviewData } from './mock';

export const getFeedbackData = async ({ policyId, claimId }) => {
  try {
    const resp = await request('get-claim-detail', {
      body: {
        claimId,
        policyId,
      },
    });
    // console.log(policyId, claimId, ' feedback接口入参');
    // const resp = MOCK_FEEDBACK_RESP(claimId);
    const { code } = resp || {};
    if (code !== RespCode.Success) {
      logError(new Error(`failed, resp=${JSON.stringify(resp)}`));
      // return null;
    }
    return resp;
  } catch (e) {
    logError(e);
    return null;
  }
};

export const updateTracking = async (claimId, values) => {
  try {
    const resp = await request('update-tracking', {
      body: {
        claimId,
        ...values,
      },
    });
    const { code } = resp || {};
    if (code !== RespCode.Success) {
      logError(new Error(`failed, resp=${JSON.stringify(resp)}`));
      return null;
    }
    return resp;
  } catch (e) {
    logError(e);
    return null;
  }
};
